import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';

/**
 * Injectable
 */
@Injectable({
  providedIn: 'root'
})
export class ProjectValuationDeleteService {
  /**
   * Constructor
   */
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) { }

  /**
  * Deletes project
  * @param oid Project oid
  */
  deleteProject(oid: any): Observable<any> {
    return this.httpClient.delete<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `Projects?oid=${oid}`)).pipe(
      map((data) => {
        if (data.m_Item2 !== "OK") {
          alert("Failed to delete project.");
        }
        return data.success;
      })
    );
  }

  /**
  * Deletes a portfolio by oid
  * @param oid Oid
  */
  deletePortfolio(oid: any) {
    return this.httpClient.delete<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `ValuationPortfolios?oid=${oid}`)).pipe(
      map((data) => {
        if (data.m_Item2 !== "OK") {
          alert("Failed to delete portfolio.");
        }
        return data.success;
      })
    );
  }

  /**
  * Deletes multiple portfolios
  * @param oids Portfolio oids
  */
  deleteMultiplePortfolios(oids: any) {
    return this.httpClient.post<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `ValuationPortfolios/delete/multiple`), oids).pipe(
      map((data) => {
        if (!data.m_Item1) {
          alert("Failed to delete portfolios.");
        }
        return data.success;
      })
    );
  }

  /**
* Deletes multiple projects
* @param oids Projects oids
*/
  deleteMultipleProjects(oids: any) {
    return this.httpClient.post<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `Projects/delete/multiple`), oids).pipe(
      map((data) => {
        if (!data.m_Item1) {
          alert("Failed to delete projects.");
        }
        return data.success;
      })
    );
  }

  /**
  * Deletes a report by oid
  * @param oid Oid
  */
  deleteReport(oid: any) {
    return this.httpClient.delete<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `Reports?oid=${oid}`)).pipe(
      map((data) => {
        if (data.m_Item2 !== "OK") {
          alert("Failed to delete report.");
        }
        return data.success;
      })
    );
  }

  /**
  * Deletes multiple reports
  * @param reportOids Reports ids
  */
  deleteMultipleReports(reportOids: any) {
    return this.httpClient.post<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `Reports/delete/multiple`), reportOids).pipe(
      map((data) => {
        if (!data.m_Item1) {
          alert("Failed to delete reports.");
        }
        return data.success;
      })
    );
  }

  /**
  * Deletes a valuation by id
  * @param scenario Scenario
  * @param valuationId Valuation id
  */
  deleteValuation(scenario: string, valuationId: any) {
    return this.httpClient.delete<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `ProjectValuationValuation/project/valuation/valuation?scenario=${scenario}&valuationId=${valuationId}`)).pipe(
      map((data) => {
        if (data.m_Item2 !== "OK") {
          alert("Failed to delete valuation.");
        }
        return data.success;
      })
    );
  }

  /**
  * Deletes a tenant by oid
  * @param tenantId Tenant id
  */
  deleteTenant(tenantId: any) {
    return this.httpClient.delete<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `ProjectValuationTenant/project/valuation/tenant?tenantId=${tenantId}`)).pipe(
      map((data) => {
        if (data.m_Item2 !== "OK") {
          alert("Failed to delete tenant.");
        }
        return data.success;
      })
    );
  }

  /**
  * Deletes multiple tenant
  * @param oids Tenant ids
  */
  deleteMultipleTenants(oids: any) {
    return this.httpClient.post<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `ProjectValuationTenant/valuation/tenant/delete/multiple`), oids).pipe(
      map((data) => {
        if (!data.m_Item1) {
          alert("Failed to delete tenants.");
        }
        return data.success;
      })
    );
  }

  /**
   * Checks if portfolio can be deleted
   * @param oid Oid
   * */
  canDeletePortfolio(oid: any): Observable<any> {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `ValuationPortfolios/canDelete?oid=${oid}`)).pipe(take(1));
  }
}
